import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { TranslocoLoader, Translation } from '@jsverse/transloco';
import type { Observable } from 'rxjs';

/**
 * Loads translation files from assets/i18n/{lang}.json.
 * Used by Transloco to fetch it.json and en.json.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);

  getTranslation(lang: string): Observable<Translation> {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}
